module.exports = __webpack_public_path__ + "media/images/smart_phone/icons/img_mie-2ffbb4d6ef79d5556b76b13fe503d457.png";